module.exports = __webpack_public_path__ + "static/media/logo.0d468a5c.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/logo.png
// module id = 265
// module chunks = 0